import type { CSSProperties } from 'react';
import { LANDING_VISUAL_THEME as tz } from './landingVisualTheme';

/** CSS variables for Login/Register to match About/Technology landing palette. */
export const AUTH_PAGE_THEME_VARS = {
  '--tz-navy': tz.navy,
  '--tz-navyElevated': tz.navyElevated,
  '--tz-navyDeep': tz.navyDeep,
  '--tz-navyCard': tz.navyCard,
  '--tz-cyan': tz.cyan,
  '--tz-cyanBright': tz.cyanBright,
  '--tz-slate': tz.slate,
  '--tz-slateMuted': tz.slateMuted,
  '--tz-cloud': tz.cloud,
  '--tz-white': tz.white,
  '--tz-glassBorder': tz.glassBorder,
  '--tz-glassBg': tz.glassBg,
} as CSSProperties;
